import type { ProductInfo } from "@expert/contentful";

/**
 * A product has "no checklist" when its {@link ProductInfo} exists but carries
 * no `salesOfferChecklist`. Such products skip the checklist-dependent
 * `SuggestedOfferStep` — enroll-vs-track is then decided purely by the product
 * flags (see {@link getEnrollmentEntryStep}).
 *
 * Shared by `IntegratedFlow` (routing / entry-step selection) and
 * `handleEnrollmentEvent` (deciding whether to re-show the guided offer screen)
 * so the definition lives in one place and the two stay in lockstep.
 */
export const isNoChecklistProduct = (productInfo: ProductInfo | undefined): boolean =>
    !!productInfo && !productInfo.salesOfferChecklist;
